module.exports = __webpack_public_path__ + "img/blabladev.e484b6ae.png";